import React from 'react';
import { styled } from '@mui/material';
import { Button } from '@mui/material';
import { FooterActionButtonProps } from './FooterActionButton.props';
import { ITheme } from '../../../../theme/types';

const PREFIX = 'FooterActionButton';

const classes = {
  actionButton: `${PREFIX}-actionButton`,
};

const StyledButton = styled(Button)(({ theme }) => ({
  [`&.${classes.actionButton}`]: {
    fontSize: '1rem',
    textTransform: 'none',
    fontWeight: 500,
    marginRight: theme.spacing(3),
    padding: '0.375rem 0',
  },
}));

const FooterActionButton = ({ title, icon, onClick, isDisabled }: FooterActionButtonProps) => (
  <StyledButton
    disabled={isDisabled}
    className={classes.actionButton}
    endIcon={icon}
    color="primary"
    onClick={onClick}>
    <span>{title}</span>
  </StyledButton>
);

export default FooterActionButton;
